import { useState } from 'react';
import Icon from 'jsx/components/core/icons/Icon';
import { Dropdown, DropdownMenu, DropdownItem, DropdownToggle, Button} from 'reactstrap';
// import ColumnFilterModal from './ColumnFilterModal';

const ColumnHeader = (props) => {
  const { header } = props;

  const [selections, setSelections] = useState([]);
  const [iconName, setIconName] = useState('filter-solid');
  // const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    // setIsFilterModalOpen((prevState) => !prevState);
    setDropdownOpen((prevState) => !prevState);
  };

  const className = (selections && selections.length > 0 ? 'text-corporate d-flex justify-content-between' : 'd-flex justify-content-between');

  const addSelection = (value) => {
    selections.push(value);
  };

  const removeSelection = (value) => {
    const idx = selections.findIndex(selection => selection === value);
    if (idx > -1) selections.splice(idx, 1);
  };

  const handleChange = (event) => {
    if (header.handleChange) {
      const label = event.target.name;
      const value = event.target.id;
      const {checked} = event.target;

      if (checked && value) {
        addSelection(value);
      } else if (!checked && value) {
        removeSelection(value);
      } else {
        selections.length = 0;
      }

      // Pass selection change to parent component
      header.handleChange({label, value, checked, selections});
    }
  };

  const renderOptions = () => header.options.map((option, index) => {
    const abbreviatedCaption = option?.name?.split(' ').reduce((accumulator, substring) => accumulator + substring[0], '');
    const name = `${option.name} (${abbreviatedCaption})`;
    const checked = selections.includes(option.id);

    return (
      <DropdownItem key={index} >
        <input className="mr-2" type="checkbox" onChange={handleChange} id={option.id} name={option.name} checked={checked}/>
        <span>{option.name}</span>
      </DropdownItem>
    );
  });

  if (selections !== header.filterSelection) setSelections(header.filterSelection);

  // if (!selections) selections = [];

  return (
    <>
      {/* {header?.options?.length > 0 && (
        <ColumnFilterModal
          toggle={toggle}
          isOpen={isFilterModalOpen}
          header={header}
          selections={selections}
          title="Filter Advisor"
          handleChange={handleChange}
        />
      )} */}

      {header?.options?.length > 0 && dropdownOpen && (
        <Dropdown isOpen={dropdownOpen} toggle={toggle}> 
          <DropdownToggle
            className="nav-link p-0"
            tag="div"
          >
            {header.shortCaption || header.caption}
            {/* {iconName && ( */}
              <Icon name={iconName} className="text-primary" style={{margin: 3}} onClick={handleChange} />
            {/* )} */}
          </DropdownToggle>

          <DropdownMenu className="bg-lightgray">
            {header?.options?.length > 1 && (
              <>
                <DropdownItem key={-1}><input className="mr-2" type="checkbox" checked={selections && selections.length === 0} onChange={handleChange}/>Show ALL</DropdownItem>
                <DropdownItem divider className="border-bottom border-corporate"/>
              </>
            )}

            {renderOptions(selections)}

            {/* <DropdownItem className="border-top border-corporate text-center"><Button size="sm" color="link" onClick={toggle}>Close</Button></DropdownItem> */}
          </DropdownMenu>
        </Dropdown>
      )}

      {(!header?.options || !dropdownOpen) && (
        <div className={className} style={header?.style} onContextMenu={() => {}}>
          <span>{header.shortCaption || header.caption}</span>

          {selections && selections.length > 0 && (
            <Icon name={iconName} className="text-success" style={{margin: 3, marginLeft: 4}} onClick={toggle}/>
          )}

          {selections && selections.length === 0 && (
            <Icon name={iconName} className="text-secondary" style={{margin: 3, marginLeft: 4, marginTop: 4}} onClick={toggle} />
          )}
        </div>
      )}
    </>
  );
};

export default ColumnHeader;
